// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"646":"6eff4b14","970":"e494b226"}[chunkId] + ".chunk.css";
};